import styled from 'styled-components/macro';

export const StyledIntensityTraffic = styled.div`
  padding: 24px;
`;
